// routes
import { PATH_AUTH, PATH_DASHBOARD, PATH_PAGE, PATH_DEVELOPERS } from '../../routes/paths';
// components
import Iconify from '../../components/Iconify';
// ----------------------------------------------------------------------


const ICON_SIZE = {
  width: 22,
  height: 22,
};

const menuConfig = [
  {
    title: 'header_menu.home',
    icon: <Iconify icon={'system-uicons:home'} {...ICON_SIZE} />,
    path: PATH_PAGE.root,
  },
  {
    title: 'header_menu.mycolab',
    icon: <Iconify icon={'carbon:sprout'} {...ICON_SIZE} />,
    path: PATH_PAGE.mycolab,
  },
  {
    title: 'header_menu.blog',
    icon: <Iconify icon={'ph:newspaper-light'} {...ICON_SIZE} />,
    path: PATH_PAGE.blog.root,
  },
  {
    title: 'header_menu.store',
    icon: <Iconify icon={'ph:address-book-light'} {...ICON_SIZE} />,
    path: PATH_PAGE.shop.root,
    children: [
      {
        subheader: 'header_menu.shop.title',
        items: [
          { title: 'header_menu.shop.products', path: PATH_PAGE.shop.root },
          { title: 'header_menu.shop.track_order', path: PATH_PAGE.shop.trackOrder },
        ],
      },
    ],
  },
  {
    title: 'header_menu.tools.tools',
    path: PATH_PAGE.tools.root,
    icon: <Iconify icon={'fluent:square-hint-apps-20-regular'} {...ICON_SIZE} />,
    children: [
      {
        subheader: 'header_menu.tools.tools',
        items: [

          { title: 'header_menu.tools.substrate_calculator', path: PATH_PAGE.tools.calc },
          { title: 'header_menu.tools.mushroom_map', path: PATH_PAGE.tools.mushroom_map },
          { title: 'header_menu.tools.quiz', path: PATH_PAGE.tools.quiz },
          { title: 'header_menu.tools.cultivation_recipes', path: PATH_PAGE.tools.recipes },
          { title: 'header_menu.tools.wood_guide', path: PATH_PAGE.tools.wood_guide },
          { title: 'header_menu.tools.contamination_guide', path: PATH_PAGE.tools.field_guide },
          { title: 'header_menu.tools.tincture_calc', path: PATH_PAGE.tools.tincture_calc },
        ],
      },
    ],
  },
  {
    title: 'header_menu.developers',
    icon: <Iconify icon={'mdi:code-braces'} {...ICON_SIZE} />,
    path: PATH_DEVELOPERS.api,
  },
  {
    title: 'header_menu.login',
    icon: <Iconify icon={'system-uicons:door-alt'} {...ICON_SIZE} />,
    path: PATH_DASHBOARD.root,
  },
];

const menuPrerelease = [
  {
    title: 'Home',
    icon: <Iconify icon='system-uicons:home' {...ICON_SIZE} />,
    path: '/prerelease',
  },
  {
    title: '¿Qué es Sporexpert?',
    path: '#section1',
    icon: <Iconify icon='fluent:info-20-regular' {...ICON_SIZE} />,
  },
  {
    title: 'Herramientas',
    path: '#section2',
    icon: <Iconify icon='system-uicons:cube' {...ICON_SIZE} />,
  },
  {
    title: 'Registrarse',
    path: '#register',
    icon: <Iconify icon='solar:user-rounded-linear' {...ICON_SIZE} />,
  },
  {
    title: 'Ingresar',
    path: PATH_AUTH.login,
    icon: <Iconify icon='system-uicons:door-alt' {...ICON_SIZE} />,
  },
];

export { menuConfig, menuPrerelease };
